import { Directive, ElementRef, HostListener } from '@angular/core';
import * as i0 from "@angular/core";
export let ValueAccessor = /*#__PURE__*/(() => {
  class ValueAccessor {
    constructor(el) {
      this.el = el;
      this.onChange = () => {};
      this.onTouched = () => {};
    }
    writeValue(value) {
      this.el.nativeElement.value = this.lastValue = value == null ? '' : value;
    }
    handleChangeEvent(value) {
      if (value !== this.lastValue) {
        this.lastValue = value;
        this.onChange(value);
      }
    }
    _handleBlurEvent() {
      this.onTouched();
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.el.nativeElement.disabled = isDisabled;
    }
  }
  /** @nocollapse */
  /** @nocollapse */ValueAccessor.ɵfac = function ValueAccessor_Factory(t) {
    return new (t || ValueAccessor)(i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  ValueAccessor.ɵdir = /** @pureOrBreakMyCode */i0.ɵɵdefineDirective({
    type: ValueAccessor,
    hostBindings: function ValueAccessor_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("focusout", function ValueAccessor_focusout_HostBindingHandler() {
          return ctx._handleBlurEvent();
        });
      }
    }
  });
  return ValueAccessor;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
